"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _styled_1 = require("../../styled-components");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ImageElement = styled_components_1.default(function (props) { return (react_1.default.createElement(_styled_1.DefaultStyled, __assign({}, props, { as: "img" }))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Image = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b, dark = _a.dark, padding = _a.padding, margin = _a.margin, height = _a.height, width = _a.width, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps, disableLazy = _a.disableLazy, disableResponsive = _a.disableResponsive;
    if (process.env.REACT_APP_CONVERT_IMAGES &&
        process.env.NODE_ENV === 'production' &&
        !src.endsWith('.svg') &&
        !disableResponsive) {
        var sizesWithFallback = [1200, 800, 380, 200, 1];
        var fileEnding_1 = src.split('.').pop();
        var srcWithoutExtension_1 = src.replace("." + fileEnding_1, '');
        return (react_1.default.createElement("picture", null,
            sizesWithFallback.map(function (size, index) {
                var suffix = index === 0 ? '' : "_" + (5 - index) + "x";
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("source", { media: "(min-width: " + size + "px)", srcSet: "" + srcWithoutExtension_1 + suffix + ".webp", type: "image/webp" }),
                    react_1.default.createElement("source", { media: "(min-width: " + size + "px)", srcSet: "" + srcWithoutExtension_1 + suffix + "." + fileEnding_1 })));
            }),
            react_1.default.createElement(ImageElement, __assign({ src: src, alt: alt, dark: dark, padding: padding, margin: margin, height: height, width: width, defaultCss: defaultCss, loading: disableLazy ? undefined : 'lazy' }, nativeProps))));
    }
    return (react_1.default.createElement(ImageElement, __assign({ src: src, alt: alt, dark: dark, padding: padding, margin: margin, height: height, width: width, defaultCss: defaultCss, loading: disableLazy ? undefined : 'lazy' }, nativeProps)));
};
exports.default = Image;
var templateObject_1;
//# sourceMappingURL=Image.js.map